import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import ApplicationBuilderPage from '../../features/application-builder/components/ApplicationBuilderPage';

const ApplicationBuilderPageRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <ApplicationBuilderPage />
    </ProtectedRoute>
  );
};

export default ApplicationBuilderPageRoute;